/*global ApeConfig*/
import React, { useState, useRef, useEffect } from 'react';
import { emitChainChange } from '../../hooks/useChainAccent';

const ChainIcon = ({ src, size = 22 }) => (
	<img src={src} width={size} height={size} style={{ display: 'block', borderRadius: '50%', objectFit: 'cover' }} alt="" />
);

export const SidebarChainSelect = ({ chainId, onChainChange, dropDirection = 'up' }) => {
	const [open, setOpen] = useState(false);
	const [selectedId, setSelectedId] = useState(() => {
		const saved = localStorage.getItem('pf-app-chain');
		return saved ? parseInt(saved) : chainId;
	});
	const ref = useRef(null);

	const chains = typeof ApeConfig !== 'undefined' ? ApeConfig : [];
	const current = chains.find(x => x.ID === selectedId) || chains.find(x => x.ID === chainId) || chains.find(x => x.Active) || chains[0];

	useEffect(() => {
		const handler = (e) => {
			if (ref.current && !ref.current.contains(e.target)) setOpen(false);
		};
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, []);

	return (
		<div ref={ref} style={{ position: 'relative' }}>
			{/* Chain icon button */}
			<button
				onClick={() => setOpen(!open)}
				title={current ? `Chain: ${current.Name}` : 'Select chain'}
				style={{
					display: 'flex', height: '32px', width: '32px', cursor: 'pointer',
					alignItems: 'center', justifyContent: 'center',
					borderRadius: '9px', border: `2px solid ${open ? 'var(--accent)' : 'rgba(244,241,232,.3)'}`,
					background: open ? 'rgba(244,241,232,.12)' : 'rgba(244,241,232,.06)',
					transition: 'transform 130ms, border-color 130ms, background 130ms, box-shadow 130ms',
				}}
				onMouseEnter={(e) => {
					e.currentTarget.style.transform = 'translateY(-2px) scale(1.08) rotate(-6deg)';
					e.currentTarget.style.borderColor = 'var(--accent)';
					e.currentTarget.style.background = 'rgba(244,241,232,.12)';
					e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,.35)';
				}}
				onMouseLeave={(e) => {
					e.currentTarget.style.transform = 'none';
					e.currentTarget.style.borderColor = open ? 'var(--accent)' : 'rgba(244,241,232,.3)';
					e.currentTarget.style.background = open ? 'rgba(244,241,232,.12)' : 'rgba(244,241,232,.06)';
					e.currentTarget.style.boxShadow = 'none';
				}}
			>
				{current && <ChainIcon src={current.ChainLogo} size={19} />}
			</button>

			{/* Dropdown menu (opens upward) */}
			<div style={{
				position: 'absolute',
				...(dropDirection === 'down'
					? { top: 'calc(100% + 8px)', left: 0 }
					: { bottom: 'calc(100% + 8px)', right: 0 }),
				minWidth: dropDirection === 'down' ? '120px' : '172px',
				borderRadius: dropDirection === 'down' ? '8px' : '10px',
				border: '2px solid rgba(244,241,232,.3)',
				background: '#1f1f1f',
				padding: dropDirection === 'down' ? '3px' : '5px',
				boxShadow: dropDirection === 'down' ? '0 8px 22px rgba(0,0,0,.45)' : '0 -8px 22px rgba(0,0,0,.45)',
				zIndex: 30,
				opacity: open ? 1 : 0,
				transform: open ? 'translateY(0) scale(1)' : `translateY(${dropDirection === 'down' ? '-6px' : '6px'}) scale(0.98)`,
				pointerEvents: open ? 'auto' : 'none',
				transition: 'opacity 150ms ease, transform 150ms ease',
				transformOrigin: dropDirection === 'down' ? 'top' : 'bottom',
			}}>
				{chains.map((chain) => (
					<button
						key={chain.ID}
						onClick={() => {
							setSelectedId(chain.ID);
							emitChainChange(chain.ID);
							if (onChainChange) onChainChange(chain.ID);
							setOpen(false);
						}}
						style={{
							display: 'flex', width: '100%', cursor: 'pointer',
							alignItems: 'center', gap: dropDirection === 'down' ? '6px' : '10px',
							borderRadius: dropDirection === 'down' ? '5px' : '7px', border: 'none',
							padding: dropDirection === 'down' ? '6px 7px' : '9px 10px', textAlign: 'left',
							fontFamily: 'var(--font-sans)', fontSize: dropDirection === 'down' ? '12px' : '15px', fontWeight: 600,
							color: '#f4f1e8',
							background: chain.ID === selectedId ? 'rgba(244,241,232,.08)' : 'transparent',
							transition: 'background 100ms',
						}}
						onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(244,241,232,.1)'; }}
						onMouseLeave={(e) => { e.currentTarget.style.background = chain.ID === selectedId ? 'rgba(244,241,232,.08)' : 'transparent'; }}
					>
						<span style={{ display: 'inline-flex', height: dropDirection === 'down' ? '16px' : '22px', width: dropDirection === 'down' ? '16px' : '22px', flexShrink: 0 }}>
							<ChainIcon src={chain.ChainLogo} size={dropDirection === 'down' ? 16 : 22} />
						</span>
						<span style={{ flex: 1 }}>{chain.Name}</span>
						{chain.ID === selectedId && (
							<svg width={dropDirection === 'down' ? 11 : 15} height={dropDirection === 'down' ? 11 : 15} viewBox="0 0 24 24" fill="none" style={{ color: 'var(--accent)' }}>
								<path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						)}
					</button>
				))}
			</div>
		</div>
	);
};
